"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { isAnalyticsSurfaceEnabled } from "@/lib/analyticsConsent";
import { useAnalyticsConsent } from "@/lib/analyticsConsentContext";

/** Bottom banner: accept analytics vs necessary-only. Hidden until a collection surface is enabled. */
export function AnalyticsConsentBanner() {
  const t = useTranslations("analyticsConsent");
  const { choice, ready, setChoice } = useAnalyticsConsent();
  if (!isAnalyticsSurfaceEnabled() || !ready || choice !== null) return null;

  return (
    <div className="gruv-analytics-consent" role="dialog" aria-labelledby="gruv-analytics-consent-title">
      <div className="gruv-analytics-consent__inner">
        <div className="gruv-analytics-consent__copy">
          <p id="gruv-analytics-consent-title" className="gruv-analytics-consent__title">
            {t("title")}
          </p>
          <p className="gruv-analytics-consent__body">
            {t("body")}{" "}
            <Link href="/privacy" className="gruv-analytics-consent__link">
              {t("privacy")}
            </Link>
          </p>
        </div>
        <div className="gruv-analytics-consent__actions">
          <button type="button" className="gruv-analytics-consent__btn gruv-analytics-consent__btn--ghost" onClick={() => setChoice("necessary")}>
            {t("necessary")}
          </button>
          <button type="button" className="gruv-analytics-consent__btn" onClick={() => setChoice("accepted")}>
            {t("accept")}
          </button>
        </div>
      </div>
    </div>
  );
}

/** Privacy-page control to change the stored analytics choice later. */
export function AnalyticsConsentSettings() {
  const t = useTranslations("analyticsConsent");
  const { choice, setChoice } = useAnalyticsConsent();
  return (
    <section className="gruv-analytics-consent-settings" aria-labelledby="gruv-analytics-consent-settings-title">
      <h2 id="gruv-analytics-consent-settings-title" className="gruv-analytics-consent-settings__title">
        {t("settingsTitle")}
      </h2>
      <p className="gruv-analytics-consent-settings__body">{t("settingsBody")}</p>
      <p className="gruv-analytics-consent-settings__status">
        {choice === "accepted" ? t("statusAccepted") : choice === "necessary" ? t("statusNecessary") : t("statusUnset")}
      </p>
      <div className="gruv-analytics-consent__actions">
        <button type="button" className="gruv-analytics-consent__btn gruv-analytics-consent__btn--ghost" onClick={() => setChoice("necessary")}>
          {t("necessary")}
        </button>
        <button type="button" className="gruv-analytics-consent__btn" onClick={() => setChoice("accepted")}>
          {t("accept")}
        </button>
      </div>
    </section>
  );
}
